/**
 * @fileoverview Zod schema for Sales Pipeline's "Reject Prospect" form.
 * @description Mirrors the backend's Reject Prospect Request rules (Confluence 3.5.12.4): one of
 * four reason codes, and a review note of 1-500 characters after trimming, required for every
 * reason. Every issue message is a translation key, translated only at the display call site in
 * RejectProspectDialog.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { z } from 'zod'

/** @description The longest review note the backend accepts. */
export const REVIEW_NOTE_MAX_LENGTH = 500

/** @description The reject form's rules. */
export const rejectApprovalFormSchema = z.object({
  reasonCode: z.enum(['INVALID_DETAILS', 'DUPLICATE_BANK', 'OUTSIDE_BUSINESS_SCOPE', 'OTHER'], {
    error: 'sales.pipeline.reject.errors.reasonRequired',
  }),
  reviewNote: z
    .string()
    .trim()
    .min(1, 'sales.pipeline.reject.errors.noteRequired')
    .max(REVIEW_NOTE_MAX_LENGTH, 'sales.pipeline.reject.errors.noteTooLong'),
})

/** @description The reject form's values. */
export type RejectApprovalFormValues = z.infer<typeof rejectApprovalFormSchema>
